module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.12930/assets/images/workflow-templates-hero.png"